import { H2 } from '@components/Typography';
import styled from 'styled-components';

export const RootContainer = styled.div`
  display: grid;
  justify-items: center;
  justify-content: center;
  padding: 6rem 12rem;
  width: 100%;
`;

export const VideoWrapper = styled.div`
  padding: 2rem;
  margin: 5rem 0 2rem 0;
  width: 1100px;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1280}) {
    width: 900px;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    width: 768px;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    margin-top: 4rem;
    width: 480px;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 400px;
  }
`;

export const TitleText = styled(H2)<{ color?: string }>`
  color: ${({ color, theme }) => color || theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size40};
  line-height: ${({ theme }) => theme.lineHeight.height130};
  text-align: center;
  margin-bottom: 1rem;
  width: 90%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
  }
`;

export const DescriptionText = styled.p`
  color: ${({ color, theme }) => color || theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size18};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  margin-bottom: 2rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size16};
  }
`;
